// src/components/onboarding/StepTimeCommitment.js

import React, { useState, useEffect } from 'react';
import './Onboarding.css';

const StepTimeCommitment = ({ value, onChange }) => {
  // Use local state to manage the slider value visually as the user drags it,
  // then call onChange to update parent state.
  const [localHours, setLocalHours] = useState(value || 5); // Default to 5 hours

  // Sync local state when parent value changes (e.g., when navigating back)
  useEffect(() => {
    if (value !== null) {
      setLocalHours(value);
    }
  }, [value]);

  const handleChange = (event) => {
    const hours = parseInt(event.target.value, 10);
    setLocalHours(hours);
    onChange(hours); // Update parent state immediately
  };

  return (
    <div className="time-commitment-input">
      <p className="input-prompt">How many hours per week can you realistically commit to learning?</p>
      
      <div className="slider-value-display">
        {localHours} {localHours === 1 ? 'Hour' : 'Hours'}
      </div>

      <div className="slider-control-wrapper">
          <input
            type="range"
            min="1"
            max="20"
            step="1"
            value={localHours}
            onChange={handleChange}
            className="time-slider"
          />
      </div>

      <div className="slider-range-labels">
        <span>1 hr/week</span>
        <span>20+ hrs/week</span>
      </div>
    </div>
  );
};

export default StepTimeCommitment;